module.exports = __webpack_public_path__ + "img/1707036453316-jkt48.JPG.bd349812.webp";